import { send } from '../../../../../../../../src/network/network';
import { type PaginatedCustomerTagListList } from '../../../../../../../../src/types/PaginatedCustomerTagListList';

export { type PaginatedCustomerTagListList };

type Params = {
  limit?: number;
  offset?: number;
  tagGroupId: number;
};

export async function getApiV2CustomersCustomerIdTagGroupsTagGroupIdTags(
  params: Params
) {
  const queryParams = new URLSearchParams();

  if (params.limit !== undefined) {
    queryParams.append('limit', params.limit.toString());
  }

  if (params.offset !== undefined) {
    queryParams.append('offset', params.offset.toString());
  }

  return await send<PaginatedCustomerTagListList>({
    path: `/api/v2/customers/self/tag_groups/${params.tagGroupId}/tags/`,
    method: 'GET',
    query: queryParams,
  });
}
